export function createPathFromTimestamp() {
    const now = new Date().getTime()
    const path = now.toString(36)
    .replace(/\B/g, () => 
      Math.floor(Math.random() * 36)
      .toString(36)
    );
    return path;
  }